/**
 * @module Feature Flagging HOC
 * @description
 */
import React, { FC, createContext } from 'react';
import type { AppProps } from 'next/app';
import { ProviderProps } from 'ui/types/providers';
import { usePhoneHeavy } from './hooks/usePhoneHeavy';
import { useCartHeavy } from './hooks/useCartHeavy';
import { useVRCEndDate } from './hooks/useVRCEndDate';

interface Props {
  phoneHeavy?: boolean;
  cartHeavy?: boolean;
  vrcEndDate?: string;
  fuseNumber?: string;
}

const defaultState = {
  phoneHeavy: false,
  cartHeavy: false,
}

export const FeatureFlagContext = createContext<Props>( defaultState );

export const withFeatureFlagging = ( { App }: ProviderProps ) => {
  const FeatureFlagProviderHOC: FC<AppProps> = ( props ) => {
    const phoneHeavy = usePhoneHeavy();
    const cartHeavy = useCartHeavy();
    const vrcEndDate = useVRCEndDate();

    return (
      <FeatureFlagContext.Provider value={ { phoneHeavy, cartHeavy, vrcEndDate } }>
        <App { ...props } />
      </FeatureFlagContext.Provider>
    );
  };

  return FeatureFlagProviderHOC;
};

export default withFeatureFlagging;
